export class OutingPermssionDto{
    public outingPermissionTypeId: string;
    public outingId: string;
    public userId: string;
    public createdBy: string;
}